<template>
  <div>
    <div v-if="isLoggedIn">
      
      <div class="dashboard pa-8">
        <h2>Welcome back, {{ user }}</h2>
        <h1>{{ dashboard }}</h1>
        <v-container class="pl-0">
          <v-row class="pa-16 pl-0 pt-0">
            <v-col cols="auto">
              <router-link to="/purchases">
                <v-card class="mx-auto" width="230" :color="createColor" :variant="variant">
                  <v-card-item>
                    <div>
                      <div class="text-overline mb-1">Create Series</div>
                      <div class="text-h6 mb-1">And Print Labels</div>
                    </div>
                  </v-card-item>
                </v-card>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link to="/serial-search">
                <v-card class="mx-auto" width="230" :color="searchColor" :variant="variant">
                  <v-card-item>
                    <div>
                      <div class="text-overline mb-1">Serial Search</div>
                      <div class="text-h6 mb-1">Searchpage</div>
                    </div>
                  </v-card-item>
                </v-card>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link to="/box-search">
                <v-card class="mx-auto" width="230" :color="boxesColor" :variant="variant">
                  <v-card-item>
                    <div>
                      <div class="text-overline mb-1">Search Boxes</div>
                      <div class="text-h6 mb-1">Packed boxes</div>
                    </div>
                  </v-card-item>
                </v-card>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link to="/reuse-serials">
                <v-card class="mx-auto" width="230" :color="serialColor" :variant="variant">
                  <v-card-item>
                    <div>
                      <div class="text-overline mb-1">Serialnumbers</div>
                      <div class="text-h6 mb-1">Reuse serialnumbers</div>
                    </div>
                  </v-card-item>
                </v-card>
              </router-link>
            </v-col>
          </v-row>
          <v-row class="pa-16 pl-0 pt-0">
            <v-col cols="auto">
              <router-link to="/filemanager">
                <v-card class="mx-auto" width="230" :color="fileManagerColor" :variant="variant">
                  <v-card-item>
                    <div>
                      <div class="text-overline mb-1">Download files</div>
                      <div class="text-h6 mb-1">txt, csv or logos</div>
                    </div>
                  </v-card-item>
                </v-card>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link to="/upload-files">
                <v-card class="mx-auto" width="230" :color="uploadColor" :variant="variant">
                  <v-card-item>
                    <div>
                      <div class="text-overline mb-1">Upload files</div>
                      <div class="text-h6 mb-1">Logos</div>
                    </div>
                  </v-card-item>
                </v-card>
              </router-link>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <div v-else>
      <p v-if="isLoggedIn">Loading dashboard...</p>
      <p v-else>Please log in to access the dashboard</p>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, computed } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();
  const createColor = ref('#6610f2')
  const serialColor = ref('#fd7e14')
  const searchColor = ref('#6f42c1')
  const boxesColor = ref('#0d6efd')
  const fileManagerColor = ref('#198653')
  const uploadColor = ref('#49cc8c')
  const user = localStorage.getItem('username');
  const dashboard = "Main menu";
  const variant = "elevated";

  onMounted(async () => {
    try {
      if (store.getters['auth/isLoggedIn']) {
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  });

  const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
  
</script>